/*
 * @Author: 孙照
 * @LastEditTime: 2023-02-20 17:46:52
 * @Description: 请求模块封装
 * @FilePath: \fuzhou\src\utils\request.js
 */
import Axios from 'axios';
import { Message } from 'element-ui';

const BASE_URL = process.env.VUE_APP_API_URL;

const TIMEOUT = 14e3;

// 默认参数
const DEFAULT_PARAMS = {
  // companyId: 'ac487c23-5b1f-4757-9812-3353d14006dc',
  // orgCode: 'MA7G8YQG7',
  companyId: process.env.VUE_APP_COMPANY_ID,
  orgCode: process.env.VUE_APP_ORG_CODE,
};

// 默认配置
const defaultOptions = {
  baseURL: BASE_URL, // 统一请求前缀
  timeout: TIMEOUT, // 默认超时时间
};

// 参数转换
function paramsToFormData (obj) {
  const formData = new FormData();
  Object.keys(obj).forEach((key) => {
    if (obj[key] instanceof Array) {
      obj[key].forEach((item) => {
        formData.append(key, item);
      });
      return;
    }
    formData.append(key, obj[key]);
  });
  return formData;
}

/**
 * 处理异常
 * @param {*} response
 */
const handleBusinessStatus = (response) => {
  const { code } = response;
  if (response && code && code !== '200') {
    const message = response.text;
    Message.error(message);
  }
};

/**
 * 处理异常
 * @param {*} error
 */
const httpErrorStatusHandle = (error) => {
  if (error && error.response) {
    const message = error.response.text;
    Message.error(message);
  }
};

function request (axiosConfig, customOptions = {}) {
  const service = Axios.create({
    ...defaultOptions,
  });

  // 自定义配置
  const CUSTOM_OPTIONS = {
    business_message_show: true, // 是否展示 status 为 200 情况下的接口信息
    error_message_show: true, // 是否展示接口错误信息 toast
    reduct_data_format: true, // 是否开启简洁的数据结构响应 即只返回 data
    form_data_params: false, // 传参是否为 formData
    default_params: true, // 默认参数
    ...customOptions,
  };

  // 请求拦截
  service.interceptors.request.use(
    (config) => {
      // 携带 token
      if (CUSTOM_OPTIONS.form_data_params) {
        config.data = paramsToFormData(config.data);
      }
      // 部分参数为统一，添加整体的默认参数
      if (CUSTOM_OPTIONS.default_params) {
        if (config.method === 'get') {
          config.params = {
            ...DEFAULT_PARAMS,
            ...config.params,
          };
        }
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  // 响应拦截
  service.interceptors.response.use(
    (response) => {
      const { business_message_show } = CUSTOM_OPTIONS;
      if (business_message_show) {
        handleBusinessStatus(response.data);
      }
      return CUSTOM_OPTIONS.reduct_data_format ? response.data : response;
    },
    (error) => {
      if (CUSTOM_OPTIONS.error_message_show) {
        httpErrorStatusHandle(error); // 处理错误状态码
      }
      return Promise.reject(error);
    },
  );

  return service(axiosConfig);
}

export default request;
